import PropTypes from 'prop-types';

import ScorePropTypes from './score';
import StatsPropTypes from './stats';

export default PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    analysisId: PropTypes.string,
    threshold: PropTypes.number,
    score: ScorePropTypes,
    statst: StatsPropTypes,
});
